export const TEMPLATE_TYPES = {
  BLANK: 'blank',
  STARTER: 'starter',
  SHARED: 'shared',
} as const;

export type TemplateType = (typeof TEMPLATE_TYPES)[keyof typeof TEMPLATE_TYPES];

export const colorLegend: Record<string, string> = {
  letter: 'primary',
  email: 'success',
  sms: 'info',
  all: 'primary',
};

export const translationOptions = [
  'Arabic',
  'Armenian',
  'Cantonese',
  'English',
  'French',
  'German',
  'Greek',
  'Hebrew',
  'Italian',
  'Japanese',
  'Korean',
  'Mandarin',
  'Portuguese',
  'Romainian',
  'Russian',
  'Spanish',
  'Tagalog',
] as const;

export type TranslationOption = (typeof translationOptions)[number];
